module.exports = __webpack_public_path__ + "media/images/quick_search/format/img_1-7a3ff2b3091774cd1b5d3857c84b4b4d.png";